import React from 'react';
import Navbar from 'react-bootstrap/Navbar';

const topfooter = (props) => {
	return (
		<Navbar bg="dark" expand="lg" style={{'marginTop' : '20px'}}>
		    <Navbar.Text style={{color: 'lightgrey', 'fontSize': '12px'}} className="navbar-text-custom">
		      {'\u00A9'} {new Date().getFullYear()} Zurado Corporation. All Rights Reserved.
		    </Navbar.Text>
		</Navbar>
	);
}

export default topfooter;